export const EXPERIMENTS = {
    // Keep Sorted by Experiment ID

    // TODO Cleanup Closed Experiment
    CAT_MW_SC_BANNER: 3904,
    GIG_IMAGE_RATIO_CONTAIN: 4232,
    CAT_I_WILL_PREFIX_REMOVAL: 4227,
    CAT_ONLINE_PRO_TOGGLE_REMOVAL: 4256,
    HAWKS_SORT_BY_PRICE_POST_FREEZE: 4352,

    // Relevant Experiments
    CARIBOU_RATING_SCORE_UPDATES: 4268,
    HAWKS_LISTINGS_SIDE_FILTERS: 4405,
    HAWKS_OVERLAY_BADGES: 4462,
    MUSTANGS_PRO_CATALOG_GRID: 4482,
    HAWKS_LISTINGS_SELLER_LANGUAGE_SIDE_FILTERS: 4508,
    AGENCIES_IN_LISTINGS_GD: 4558,
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_GUEST: 4605,
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_USER: 4606,
    PROFESSION_BASED_CATALOG_LISTINGS_3: 4585,
    PROFESSION_BASED_CATALOG_LISTINGS_4: 4607,
    MEERKATS_LISTINGS_TIPS: 4778,
    MEERKATS_LISTINGS_AGGREGATE_RATING: 4759,
    ZEBRAS_MP_HOURLY_FILTER: 4736,

    HAWKS_FACET_COUNTER_REMOVAL: 4771,
    OWLS_FILTER_PLUS_EXPERIMENT: 4772,
    DOLPHINS_LOYALTY_ELIGIBILITY_CELEBRATION_MIGRATION: 4929,
    HAWKS_LISTINGS_STORE_BUILDER_WIZARD_EP: 4894,
    BULLS_AD_LABEL_FULL_CATALOG: 4984,
    CHEETAHS_BOOK_PUBLISHING: 5142,
    OWLS_AGENCIES_REVERSE_TEST: 4983,
    CROWS_PRO_CATALOG_NO_RESULTS: 5065,
    CROWS_MP_BFF_EXPANSION: 5159,
};
